import { c as _c } from "react/compiler-runtime";
import { Lightning01Icon } from '@systemeio/icons';
import { RulePickerModal } from 'modules/automation-rules/components/rule-picker-modal';
import { triggerCategoryOrder, TriggerItem } from 'modules/automation-rules/triggers/constants/trigger-items';
import { AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import React from 'react';
import { IconTile } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface AddTriggerModalProps {
  opened: boolean;
  onClose: () => void;
  onAddTrigger: (trigger: AutomationRuleTriggersEnum) => void;
  items: TriggerItem[];
}
const AddTriggerModal = t0 => {
  const $ = _c(14);
  const {
    opened,
    onClose,
    onAddTrigger,
    items
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconTile tone="primary"><Lightning01Icon /></IconTile>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("dashboard.automation_rule.edit.add_trigger");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="flex items-center gap-2.5">{t1}<span>{t2}</span></span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onAddTrigger || $[6] !== onClose) {
    t4 = slug => {
      onAddTrigger(slug);
      onClose();
    };
    $[5] = onAddTrigger;
    $[6] = onClose;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== items || $[9] !== onClose || $[10] !== opened || $[11] !== t3 || $[12] !== t4) {
    t5 = <RulePickerModal title={t3} opened={opened} onClose={onClose} categoryOrder={triggerCategoryOrder} dataTest="automation-rule-trigger-option" items={items} onSelect={t4} />;
    $[8] = items;
    $[9] = onClose;
    $[10] = opened;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default AddTriggerModal;